import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import * as ROUTES from './Routes';
import Template from '../widgets/template';
import { TOKEN } from '../constants/ConfigConst';
import ConfirmEmailModule from '../modules/auth/recover/confirm';
import * as MODULE from '../modules';
import { routesMap } from './modules';

const Routers = () => {
  return (
    <Router>
      <Switch>
        <PublicPage path="/" exact>
          <MODULE.Login />
        </PublicPage>
        <PublicPage path={ROUTES.login.to} exact>
          <MODULE.Login />
        </PublicPage>
        <PublicPage path={ROUTES.register.to} exact>
          <MODULE.Register />
        </PublicPage>
        <PublicPage path={ROUTES.recover.to} exact>
          <MODULE.Recover />
        </PublicPage>
        <PublicPage path={ROUTES.confirmEmail.to} exact>
          <ConfirmEmailModule />
        </PublicPage>
        {/* <PublicPage path={ROUTES.register.to} exact >
					<RegisterPage />
				</PublicPage> */}

        <Template>
          <Switch>
            <PrivatePage path={ROUTES.dashboard.to} exact>
              <MODULE.Dashboard />
            </PrivatePage>

            {Object.entries(routesMap).map(([route, Component]) => (
              <PrivatePage path={route} exact key={route}>
                <Component />
              </PrivatePage>
            ))}
          </Switch>
        </Template>
      </Switch>
    </Router>
  );
};

const validarToken = () => {
  const token = localStorage.getItem(TOKEN);
  let isValid = false;
  try {
    isValid = token && token !== '';
  } catch (e) {
    return false;
  }
  return isValid;
};

export const PublicPage = ({ children, ...props }) => {
  let isAuthenticated = validarToken();
  return !isAuthenticated ? (
    <Route {...props}> {children} </Route>
  ) : (
    <Redirect to={ROUTES.dashboard.to} />
  );
};

export const PrivatePage = ({ children, ...props }) => {
  let isAuthenticated = validarToken();
  return isAuthenticated ? (
    <Route {...props}> {children} </Route>
  ) : (
    <Redirect to={ROUTES.login.to} />
  );
};

export default Routers;
